import React, { useEffect, useState } from 'react';

export const remainingAccess = (expiresAt, now = Date.now()) => {
    const seconds = Math.max(0, Math.ceil((new Date(expiresAt).getTime() - now) / 1000));
    if (!seconds) return 'Access expired';
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor(seconds / 3600) % 24;
    const minutes = Math.floor(seconds / 60) % 60;
    return `${days ? `${days}d ` : ''}${hours}h ${minutes}m ${seconds % 60}s remaining`;
};

export default function AccessExpiry({ expiresAt }) {
    const [now, setNow] = useState(Date.now);
    useEffect(() => {
        const timer = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(timer);
    }, []);
    if (!expiresAt) return null;
    return <span title={`Access expires ${new Date(expiresAt).toLocaleString()}`}>{remainingAccess(expiresAt, now)}</span>;
}
